import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.svg";
import "../Style.css";
import OptimizedImage from "./OptimizedImage";

export default function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    {
      path: "/",
      text: "Home",
      icon: "/HomeIcon.png",
    },
    {
      path: "/coachingservices",
      text: "Services",
    },
    {
      path: "/workshops-seminars",
      text: "Workshops & Seminars",
    },
    {
      path: "/about",
      text: "About | Contact",
    },
    {
      path: "/communityresources",
      text: "Community Resources",
    },
  ];

  return (
    <header className="header">
      <nav className="navbar">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          ☰
        </button>

        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={location.pathname === link.path ? "active" : ""}
              >
                {link.icon && (
                  <OptimizedImage
                    src={link.icon}
                    alt={`${link.text} Icon`}
                    width="24"
                    height="24"
                    sizes="24px"
                    style={{
                      height: "1.5rem",
                      marginRight: ".24rem",
                      marginBottom: ".4rem",
                      verticalAlign: "middle",
                    }}
                  />
                )}
                {link.text}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
